"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Event = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Event = /*#__PURE__*/function () {
  function Event() {
    _classCallCheck(this, Event);

    _defineProperty(this, "listeners", {});

    _defineProperty(this, "onceListeners", {});

    _defineProperty(this, "eventId", "event_".concat(new Date().getTime()));
  }

  _createClass(Event, [{
    key: "on",
    value: function on(name, listener) {
      if (!listener.name) {
        console.log('event: 事件监听请勿使用匿名函数，否则无法清除');
      }

      if (!this.listeners[name]) {
        this.listeners[name] = [listener];
      } else {
        this.listeners[name].push(listener);
      }
    }
  }, {
    key: "once",
    value: function once(name, listener) {
      if (!listener.name) {
        console.log('event: 事件监听请勿使用匿名函数，否则无法清除');
      }

      if (!this.listeners[name]) {
        this.onceListeners[name] = [listener];
      } else {
        this.onceListeners[name].push(listener);
      }
    }
  }, {
    key: "off",
    value: function off(name, listener) {
      if (listener && !listener.name) {
        console.log('event: 事件清除请勿使用匿名函数，否则无效');
      }

      if (!name) {
        this.listeners = {};
        return;
      }

      if (!listener) {
        delete this.listeners[name];
        return;
      }

      this.listeners[name] = this.listeners[name].filter(function (fn) {
        return fn !== listener;
      });

      if (!this.listeners[name].length) {
        delete this.listeners[name];
      }
    }
  }, {
    key: "emit",
    value: function emit(name) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      this.callListeners.apply(this, [this.listeners[name], false].concat(args));
      this.callListeners.apply(this, [this.onceListeners[name], true].concat(args));
    }
  }, {
    key: "callListeners",
    value: function callListeners(listeners, once) {
      var _this = this;

      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      if (!listeners || !listeners.length) {
        return;
      }

      listeners.forEach(function (listener) {
        listener.apply(void 0, args);

        if (once) {
          _this.off(name, listener);
        }
      });
    }
  }]);

  return Event;
}();

exports.Event = Event;


//////////////////
// WEBPACK FOOTER
// ./~/@weike/toolkit/lib/event/index.js
// module id = 621
// module chunks = 6